import { Injectable } from "@angular/core";
import firebase from "firebase/app";
import {
  AngularFirestore,
  AngularFirestoreCollection
} from "angularfire2/firestore";
//import { combineLatest, pipe, of, defer, Timestamp } from 'rxjs';
import { map } from 'rxjs/operators';
import { rejects } from "assert";
import { leftJoin} from "../database/leftjoin";
import * as moment from 'moment';
import { Headers, RequestOptions, Http } from "@angular/http";
import { AuthProvider } from "../auth/auth";
import { _ } from "ag-grid-community";
import { AppConfig } from "../config";

export interface Other {
  userId: string;
  createdAt: Date;
  image: string;
  content: string;
  [key: string]: any;
}

export interface clinic {
  id?: string;
  clinic_id: string;
  clinic_name: string;
  createdAt: any;
  updatedAt: any;
}

export interface medication {
  id?: string;
  din: string;
  name: string;
  type: string;
  createdAt: any;
  updatedAt: any;
  logo?: string;
  category?: string;
  sort?: number;
}

export interface doctor {
  id?: string;
  first_name: string;
  last_name: string;
  license: string;
  createdAt: any;
  updatedAt: any;
}

export interface patient {
  id?: string;
  first_name: string;
  last_name: string;
  email: string;
  phone_number: string;
  address: string;
  city: string;
  postal_code: string;
  province: string;
  shipping_address: string;
  shipping_city: string;
  shipping_postal_code: string;
  address2: string;
  shipping_address2: string;
  shipping_province: string;
  gender: string;
  dob: string;
  createdAt: any;
  updatedAt: any;
}

export interface study {}

@Injectable()
export class DatabaseProvider {

  private clinicsRef: AngularFirestoreCollection<clinic>;

  constructor(private afs: AngularFirestore, public http: Http, public auth: AuthProvider) {

  }

  /*********CLINICS **********************************/
  // Get Clinics
  getClinics() {
    return this.afs.collection<clinic>("clinics", ref =>
      ref
        .orderBy("clinic_name", "asc")
    );
  }

  // Get Single Clinic
  getClinic(id) {
    return this.afs.collection<clinic>(`clinics`).doc(id);
  }

    // Create Clinic
    createClinic(data: clinic) {
      const id = this.afs.createId();
      const createdAt = firebase.firestore.FieldValue.serverTimestamp();
      const updatedAt = createdAt;
      const doc = { createdAt, updatedAt, ...data };
      return this.afs.collection<clinic>("clinics").add(doc);
    }


  // Update Clinic
  updateClinic(id: string, data: clinic)  {
    return this.afs.collection<clinic>("clinics").doc(id).update(data);
  }

  getUserStatus(userId: string) {
    return this.afs.collection("users", ref =>
      ref
        .where("userId", "==", userId)
        .limit(1)
    );
  }

  getClinicsByUser(userId: string) {
    return this.afs.collection<clinic>("clinics", ref =>
      ref
        .orderBy("createdAt", "desc")
        .where("userId", "==", userId)
        .limit(10)
    );
  }

  getStudyByPatient(patient_id: string) {
    return this.afs.collection<any>("studyresults", ref =>
    ref
      .where("patient_id", "==", patient_id)
    );
  }

  deleteMedicationFromClinic(clinic_id, medication_din)  {
    var batch = this.afs.firestore.batch();
    const doctorRef = this.afs.doc(`clinics/${clinic_id}/medications/${medication_din}`).ref;
    batch.delete(doctorRef);
    return batch.commit();
  }

  /********* MEDICATIONS **********************************/
  // Get All Medications
  getMedications() {
    return this.afs.collection<medication>("medications", ref => 
      ref.orderBy("name", "asc")
    );
  }

  // Get All Medications By Clinic
  getMedicationsByClinic(clinic_id) {
    return this.afs.collection<medication>(`clinics/${clinic_id}/medications`, ref =>
      ref
      .orderBy("sort", "asc")
      .orderBy("name", "asc")
    );
  } 

    // Get Prescription Medications By Clinic
    getMedicationsPrescriptionByClinic(clinic_id, study_id) {
      const meds$ = this.afs.collection<medication>(`clinics/${clinic_id}/medications`, ref =>
        ref
          .where("type", "==", "Prescription")
          .orderBy("sort", "asc")
          .orderBy("name", "asc")
      ).valueChanges();
      if(study_id)  {
        return meds$.pipe( 
          leftJoin(this.afs, 'study_id', 'studies', 100, study_id)
        )
      } else {
        return meds$.pipe( 
          leftJoin(this.afs, 'study_id', 'studies', 100, null)
        )
      }

    } 

  // Get Over The Counter Medications By Clinic
  getMedicationsOTCByClinic(clinic_id) {
    return this.afs.collection<medication>(`clinics/${clinic_id}/medications`, ref =>
      ref
      .where("type", "==", "Over The Counter")
      .orderBy("name", "asc")
    );
  } 

  getEnrolmentCount(clinic_id) {

  }




  updateStudy(id, renewed) {
    console.log("ID: ", id);
    console.log("Renewed: ", renewed)
    return this.afs.doc(`studyresults/${id}`).update({
        "Renewed": renewed
    });
  }

  updateStudyStatus(clinic_id, patient_id, id, status) {
    console.log('Update DB Status: ', status)
    var batch = this.afs.firestore.batch();

    const preRef = this.afs.doc(`studyresults/${id}`).ref;
    batch.update(preRef, {"_status": status});

    const clinicRef = this.afs.doc(`clinics/${clinic_id}/studyresults/${id}`).ref;
    batch.update(clinicRef, {"_status": status});

    const patientRef = this.afs.doc(`clinics/${clinic_id}/patients/${patient_id}/studyresults/${id}`).ref;
    batch.update(patientRef, {"_status": status});

    return batch.commit();
  }

  getDoctors() {
    return this.afs.collection<doctor>(`doctors`, ref =>
      ref.orderBy("last_name", "asc")
    );
  }

  getDoctorsByClinic(clinic_id) {
    return this.afs.collection<doctor>(`clinics/${clinic_id}/doctors`, ref =>
      ref.orderBy("last_name", "asc")
    );
  }

  updateDoctor(clinic_id, doctor_id, data: doctor) {
    const updatedAt = this.timestamp;
    const doc = { updatedAt, ...data };

    return this.afs.doc(`clinics/${clinic_id}/doctors/${doctor_id}`).update(doc);
  }

  addDoctor(clinic_id, data: doctor) {
    const createdAt = this.timestamp;
    const updatedAt = createdAt;
    const doctorId = this.afs.createId();
    const doc = { createdAt, updatedAt, ...data };

    return this.afs.doc(`clinics/${clinic_id}/doctors/${doctorId}`).set(doc);
  }

  deleteDoctor(clinic_id, doctor_id) {
    var batch = this.afs.firestore.batch();
    const doctorRef = this.afs.doc(`clinics/${clinic_id}/doctors/${doctor_id}`).ref;
    batch.delete(doctorRef);
    return batch.commit();
  }



  getStudyForMedicationsByClinic(clinic_id, documentreference) {
    return this.afs.doc(documentreference);
  } 


  getStudiesByClinic(clinic_id) {
    return this.afs.collection<doctor>(`clinics/${clinic_id}/studyresults`);
  } 

  getStudyEnrolments() {
    return this.afs.collection<doctor>(`studyresults`);
  } 

  savePrescription(clinic_id: string, clinic_name: string, patient_id: string, order, old_prescription_id: string, studyresult) {
    console.log("Clinic: ", clinic_id);
    console.log("Clinic Name: ", clinic_name);
    console.log("Patient ID: ", patient_id);
    console.log("Order: ", order)
    order['status'] = "Queued";
    order['clinic_id'] = clinic_id;
    order['clinic_name'] = clinic_name;
    order['patient_id'] = patient_id;
    order['doctor_id'] = order.doctor.id;
    order['createdAt'] = this.timestamp;

    const id = this.afs.createId();

    var batch = this.afs.firestore.batch();
    const preRef = this.afs.doc(`prescriptions/${id}`).ref;
    batch.set(preRef , order);

    const clinicRef = this.afs.doc(`clinics/${clinic_id}/prescriptions/${id}`).ref;
    batch.set(clinicRef , order);

    const patientRef = this.afs.doc(`clinics/${clinic_id}/patients/${patient_id}/prescriptions/${id}`).ref;
    batch.set(patientRef , order);

    if(old_prescription_id) {
      const old_preRef = this.afs.doc(`prescriptions/${old_prescription_id}`).ref;
      batch.update(old_preRef, {"Renewed": true, "past_prescription_id": old_prescription_id});
  
      const old_clinicRef = this.afs.doc(`clinics/${clinic_id}/prescriptions/${old_prescription_id}`).ref;
      batch.update(old_clinicRef, {"Renewed": true, "past_prescription_id": old_prescription_id });
  
      const old_patientRef = this.afs.doc(`clinics/${clinic_id}/patients/${patient_id}/prescriptions/${old_prescription_id}`).ref;
      batch.update(old_patientRef, {"Renewed": true, "past_prescription_id": old_prescription_id });
    }

    if(studyresult.study) {
      const createdAt = this.timestamp;
      const updatedAt = createdAt;
      const study_id = this.afs.createId();

      const studydoc = { createdAt, updatedAt, ...studyresult };
      console.log("presave study: ", studydoc)
      const study_preRef = this.afs.doc(`studyresults/${study_id}`).ref;
      batch.set(study_preRef , studydoc);
  
      const study_clinicRef = this.afs.doc(`clinics/${clinic_id}/studyresults/${study_id}`).ref;
      batch.set(study_clinicRef , studydoc);
  
      const study_patientRef = this.afs.doc(`clinics/${clinic_id}/patients/${patient_id}/studyresults/${study_id}`).ref;
      batch.set(study_patientRef , studydoc);
    }

    return batch.commit();
  }

  getPatientsByClinic(clinic_id) {
    return this.afs.collection<any>(`clinics/${clinic_id}/patients`, ref =>
      ref.orderBy("last_name", "asc")
    );
  }

  getPrescriptions() {
    return this.afs.collection<any>(`prescriptions`, ref => {
      let query : firebase.firestore.CollectionReference | firebase.firestore.Query = ref;
      if (status) { query = query.where('status', '==', status) };
      return query.orderBy("createdAt", "desc")
    })
  }

  getPrescriptionsbyClinic(clinic_id) {
    return this.afs.collection<any>(`clinics/${clinic_id}/prescriptions`, ref =>
      ref
      .orderBy("createdAt", "desc")
    );
  }

  getPrescriptionsbyPatient(clinic_id: string, patient_id: string) {
    return this.afs.collection<any>(`clinics/${clinic_id}/patients/${patient_id}/prescriptions`, ref =>
      ref
      .orderBy("createdAt", "desc")
    );
  }

  getStudiesByPatient(clinic_id: string, patient_id: string) {
    return this.afs.collection<any>(`clinics/${clinic_id}/patients/${patient_id}/studyresults`, ref =>
      ref
      .orderBy("createdAt", "desc")
    );
  }

  getStudyById(study_id: string) {
    return this.afs.collection('studies').doc(study_id);
  }


  addPatient(clinic_id, data: patient) {
    return new Promise<any>((resolve, reject) => {
    const createdAt = this.timestamp;
    const updatedAt = createdAt;
    const patientId = this.afs.createId();
    const doc = { createdAt, updatedAt, ...data };
    const afscoll = this.afs.collection(`clinics/${clinic_id}/patients`)
    afscoll.doc(patientId).set(doc).then((setdoc) => {
      console.log(patientId)
      resolve(patientId);
    })
    .catch((err) => {
      rejects(err);
    })
  });
  }

  getPatientFromClinic(clinic_id, patient_id) {
    console.log(clinic_id + ' - ' + patient_id)
    return this.afs.collection<any>(`clinics/${clinic_id}/patients/`).doc(patient_id);
  }

  updatePatient(clinic_id, data: patient) {
    const updatedAt = this.timestamp;
    const patientId = data.id;
    const doc = { updatedAt, ...data };
    return this.afs.doc(`clinics/${clinic_id}/patients/${patientId}`).update(data);
  }

  //// HEARTS ////
  /*
  createHeart(userId: string, clinic: Clinic) {
    const hearts = clinic.hearts || {};
    hearts[userId] = true;

    return this.afs.doc(`clinics/${clinic.id}`).update({ hearts });
  }

  removeHeart(userId: string, clinic: Clinic) {
    const hearts = clinic.hearts;
    delete clinic.hearts[userId];

    return this.afs.doc(`clinics/${clinic.id}`).update({ hearts });
  }
  */
  //// RELATIONSHIPS ////

  getUsers() {
    return this.afs.collection("users", ref => 
      ref.orderBy("last_name", "asc")
    );
  }

  async updateUser(user_id, data) {
    return await this.afs.collection('users').doc(user_id).set(data, {merge: true});
  }

  deletePatient(clinic_id, patient_id) {
    var batch = this.afs.firestore.batch();
    const patientRef = this.afs.doc(`clinics/${clinic_id}/patients/${patient_id}`).ref;
    batch.delete(patientRef);
    return batch.commit();
  }

  async addMedication(med)  {
    return await this.afs
    .collection("medications")
    .doc(med.din)
    .set(med);
  }

  async addMedicationByClinic(clinic_id, med)  {
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();
    const updatedAt = createdAt;
    const doc = { createdAt, updatedAt, ...med };
    return await this.afs
    .collection(`clinics/${clinic_id}/medications`)
    .doc(med.din)
    .set(doc);
  }

  async updateMedicationByClinic(clinic_id, med)  {
    const updatedAt = firebase.firestore.FieldValue.serverTimestamp();
    const doc = { updatedAt, ...med };
    return await this.afs
    .collection(`clinics/${clinic_id}/medications`)
    .doc(med.din)
    .update(doc);
  }

  follow(followerId: string, followedId: string) {
    const docId = this.concatIds(followerId, followedId);
    const createdAt = firebase.firestore.FieldValue.serverTimestamp();

    const data = {
      followerId,
      followedId,
      createdAt
    };

    return this.afs
      .collection("relationships")
      .doc(docId)
      .set(data);
  }

  unfollow(followerId: string, followedId: string) {
    const docId = this.concatIds(followerId, followedId);

    return this.afs
      .collection("relationships")
      .doc(docId)
      .delete();
  }

  isFollowing(followerId: string, followedId: string) {
    const docId = this.concatIds(followerId, followedId);

    return this.afs
      .collection("relationships")
      .doc(docId)
      .valueChanges();
  }

  getDoc(path,document)  {
    return this.afs.collection<clinic>(path).doc(document);
  }

  setDoc(path,document_id, document) {
    return this.afs
    .collection(path)
    .doc(document_id)
    .set(document);    
  }

  updateDoc(path,document_id, document) {
    return this.afs
    .collection(path)
    .doc(document_id)
    .update(document);
  }

  getCollection(path)  {
    return this.afs.collection<any>(path);
  }

  setDocWithID(path, document) {
    return new Promise<any>((resolve, reject) => {
      const createdAt = this.timestamp;
      const updatedAt = createdAt;
      const id = this.afs.createId();
      const doc = { id, createdAt, updatedAt, ...document };
      const afscoll = this.afs.collection(path)
      afscoll.doc(id).set(doc).then((setdoc) => {
        console.log(id)
        resolve(id);
      })
      .catch((err) => {
        rejects(err);
      })
    });
  }


  // Helper to format the docId for relationships
  private concatIds(a: string, b: string) {
    return `${a}_${b}`;
  }

  get timestamp() {
    return firebase.firestore.FieldValue.serverTimestamp();
  }

  createStudy(clinic_id, patient_id, studydata, old_study_id): Promise<void> {

    if(!studydata.createdAt)  {
      studydata.createdAt = this.timestamp;
      studydata.updatedAt = this.timestamp;
    }
   
    const id = this.afs.createId();

    var batch = this.afs.firestore.batch();
    const preRef = this.afs.doc(`studyresults/${id}`).ref;
    batch.set(preRef , studydata);

    const clinicRef = this.afs.doc(`clinics/${clinic_id}/studyresults/${id}`).ref;
    batch.set(clinicRef , studydata);

    const patientRef = this.afs.doc(`clinics/${clinic_id}/patients/${patient_id}/studyresults/${id}`).ref;
    batch.set(patientRef , studydata);

    if(old_study_id)  {
      const old_preRef = this.afs.doc(`studyresults/${old_study_id}`).ref;
      batch.update(old_preRef, {"Renewed": true, "past_study_id": old_study_id });
  
      const old_clinicRef = this.afs.doc(`clinics/${clinic_id}/studyresults/${old_study_id}`).ref;
      batch.update(old_clinicRef, {"Renewed": true, "past_study_id": old_study_id });
  
      const old_patientRef = this.afs.doc(`clinics/${clinic_id}/patients/${patient_id}/studyresults/${old_study_id}`).ref;
      batch.update(old_patientRef, {"Renewed": true, "past_study_id": old_study_id });
    }

    return batch.commit();
  }

  completeStudy(study_id, clinic_id, patient_id, study): Promise<void> {
    study.updatedAt = this.timestamp;
    var batch = this.afs.firestore.batch();

      const old_preRef = this.afs.doc(`studyresults/${study_id}`).ref;
      batch.update(old_preRef, study);
  
      const old_clinicRef = this.afs.doc(`clinics/${clinic_id}/studyresults/${study_id}`).ref;
      batch.update(old_clinicRef,study);
  
      const old_patientRef = this.afs.doc(`clinics/${clinic_id}/patients/${patient_id}/studyresults/${study_id}`).ref;
      batch.update(old_patientRef, study);

    return batch.commit();
  }

  getStudiesByClinicFollowUp(clinic_id)  {
    let dueDate: moment.Moment = moment();
    dueDate = dueDate.add(-10, "M");
    return this.afs.collection<any>(`clinics/${clinic_id}/studyresults`, ref => 
      ref
        .where('Renewed', '==', false)
        .where('createdAt', '<', dueDate.toDate())
        .orderBy('createdAt')
      );
  }

  getPrescriptionsByClinicFollowUp(clinic_id)  {
    let dueDate: moment.Moment = moment();
    dueDate = dueDate.add(-10, "M");
    return this.afs.collection<any>(`clinics/${clinic_id}/prescriptions`, ref => 
      ref
        .where('Renewed', '==', false)
        .where('createdAt', '<', dueDate.toDate())
        .orderBy('createdAt')
      );
  }

  updatePrescriptionAndStudies(status, comment, prescription_id, clinic_id, patient_id, user_id, display_name, studies)  {
    const fulfilledAt = this.timestamp;
    let updateData: any = {};
    updateData.status = status;

    if(status !== "Queued") {
    updateData.fulfilled = {};

    updateData.fulfilled.fullFilledAt = fulfilledAt;
    updateData.fulfilled.id = user_id
    updateData.fulfilled.display_name = display_name;
    updateData.fulfilled.comment = comment;
    

    console.log("Update Prescription: ", prescription_id)
    console.log("Update Prescription: ", clinic_id)
    console.log("Update Prescription: ", patient_id)
    console.log("Update Prescription: ", updateData)
    }
    var batch = this.afs.firestore.batch();
    const preRef = this.afs.doc(`prescriptions/${prescription_id}`).ref;
    batch.update(preRef , updateData);

    const clinicRef = this.afs.doc(`clinics/${clinic_id}/prescriptions/${prescription_id}`).ref;
    batch.update(clinicRef , updateData);

    const patientRef = this.afs.doc(`clinics/${clinic_id}/patients/${patient_id}/prescriptions/${prescription_id}`).ref;
    batch.update(patientRef , updateData);

    if(status === "Cancelled") {
      _.forEach(studies, (study) => {

        console.log(study);

        const preStudyRef = this.afs.doc(`studyresults/${study['id']}`).ref;
        batch.update(preStudyRef, {"_status": "cancelled"});
    
        const clinicStudyRef = this.afs.doc(`clinics/${study['clinic_id']}/studyresults/${study['id']}`).ref;
        batch.update(clinicStudyRef, {"_status": "cancelled"});
    
        const patientStudyRef = this.afs.doc(`clinics/${study['clinic_id']}/patients/${study['patient_id']}/studyresults/${study['id']}`).ref;
        batch.update(patientStudyRef, {"_status": "cancelled"});
      });
    }
    return batch.commit();
  }

  deleteUser(uid) {

    var headers = new Headers()
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let options = new RequestOptions({ headers: headers });
    let body =  "secret=123456&uid=" + uid;
    
    return new Promise((resolve, reject) => {
       this.http.post(AppConfig.constants.FS_FUNCTIONS_URL + '/deleteUser', body, options)
          .pipe(
            map(res => res.json()) // or any other operator
          )
          .subscribe(
          (data) => {
              // console.log('information from the api call',data);
              // this.local.set('agendaData', data);

              //this.data = data;
              resolve(data);
          },
          (err) => {
              if (err.status === 401) {
                  // return to login screen - Unauthorized
                  reject(new Error('You currently don’t have access to Scheduler. Please contact support'));

              }
              else if (err.status === 403) {
                  //Display Exception message, and go to support view - Forbidden
                  reject(new Error("Your access is forbidden."))
              }
              else if (err.status === 400) {
                  console.error(err);
                  if (err._body) {
                      console.info(err._body);
                      reject(new Error(err._body));
                  }
                  else
                      reject(new Error(err.statusText));
              }
              else {
                  reject(new Error("Could not save data to the server."));
              }

          }
          )
  });
  }

  createUser(user) {
  
    var headers = new Headers()
    headers.append('Content-Type', 'application/x-www-form-urlencoded');
    let options = new RequestOptions({ headers: headers });
    let body = 'secret=123456&email=' + user.email + '&password=' + user.password + '&phone_number=' + encodeURIComponent(user.phone_number) + '&first_name=' + encodeURIComponent(user.first_name) + '&last_name=' + encodeURIComponent(user.last_name) + '&clinic_id=' + user.clinic_id + '&clinic_name=' + encodeURIComponent(user.clinic_name) + '&opteva_admin=' + user.opteva_admin + '&clinic_admin=' + user.clinic_admin + '&clinic_patient=' + user.clinic_patient + '&clinic_tester=' + user.clinic_tester;
    
    return new Promise((resolve, reject) => {
       this.http.post(AppConfig.constants.FS_FUNCTIONS_URL + 'createUser', body, options)
          .pipe(
            map(res => res.json()) // or any other operator
          )
          .subscribe(
          (data) => {
              // console.log('information from the api call',data);
              // this.local.set('agendaData', data);

              //this.data = data;
              resolve(data);
          },
          (err) => {
              if (err.status === 401) {
                  // return to login screen - Unauthorized
                  reject(new Error('You currently don’t have access to Scheduler. Please contact support'));

              }
              else if (err.status === 403) {
                  //Display Exception message, and go to support view - Forbidden
                  reject(new Error("Your access is forbidden."))
              }
              else if (err.status === 400) {
                  console.error(err);
                  if (err._body) {
                      console.info(err._body);
                      reject(new Error(err._body));
                  }
                  else
                      reject(new Error(err.statusText));
              }
              else {
                  reject(new Error("Could not save data to the server."));
              }

          }
          )
  });
  }
}



// WEBPACK FOOTER //
// ./src/providers/database/database.ts